import { remove } from '@core/api/baseApi';

const deleteReportFromEvodicomService = async (
  studyInstanceUid: string,
  sopInstanceUid: string,
): Promise<void> => await remove(`/studies/${studyInstanceUid}/reports/${sopInstanceUid}`);

export default deleteReportFromEvodicomService;
